/**
 * The content variant to request for a school accent.
 *
 * No content has nz versions yet, so nz uses au unless `nzAware` (Mathseeds caper, once an nz build exists).
 *
 * RE/REX caper activities (incl books) and Jester activities pass `canadaAware: false` (unless canada aware) to redirect
 * ca to us. MS caper and non-preview lookups keep ca (the default).
 * https://3plearning.slack.com/archives/C01QGSBD52R/p1714521134159539
 * https://github.com/blake-education/fast-phonics-client/blob/e06e18742ac4d7365b8ede9a2e6dce2d8102d6df/app/services/session.ts#L103-L112
 */
export function contentVariant(accent: string, { canadaAware = true, nzAware = false } = {}): string {
  if (accent === 'nz') return nzAware ? 'nz' : 'au'
  if (accent === 'ca') return canadaAware ? 'ca' : 'us'
  return accent
}
